import React, { useEffect } from 'react'
import Header from './Header'
import FindUsOnSocials from '../global/FindUsOnSocials'
import GlobalFooter from '../global/GlobalFooter'
import { useLocation } from 'react-router-dom'

interface LayoutProps {
  children: React.ReactNode
}


const Layout: React.FC<LayoutProps> = ({ children }) => {
    const { pathname } = useLocation()
    
      useEffect(() => {
        console.log('sccroll to top')
        window.scrollTo(0, 0)
      }, [pathname])
      
  return (
    <div className="min-h-screen" style={{ margin: 0, padding: 0 }}>
      <Header />
      {children}
      <FindUsOnSocials />
      <GlobalFooter />
    </div>
  )
}

export default Layout